import { createSelector } from 'reselect';
import ReactionsConstants from 'Shared/constants/Reactions.constants';

const getReactionItems = state => state.reactionItems;

function createParameterSelector(selector) {
  return (_, params) => selector(params);
}

const getReactionableType = createParameterSelector(params => params.reactionableType);
const getReactionableId = createParameterSelector(params => params.reactionableId);

const getAllReactions = createSelector([getReactionItems], reactions =>
  reactions.get(ReactionsConstants.State.REACTIONS_BY_REACTION_SLUG)
);
export const getReactionsByReactionableId = createSelector(
  [getAllReactions, getReactionableId],
  (reactions, reactionableId) => reactions.filter(reaction => reaction.get('reactionableId') === reactionableId)
);

export const getReactionsByReactionIdAndReactionType = createSelector(
  [getReactionsByReactionableId, getReactionableType],
  (reactions, type) => {
    return reactions.filter(reaction => reaction.get('reactionableType').toLowerCase() === type.toLowerCase());
  }
);
